namespace Portico.Models.Legacy {
    
    export class PatientLookupRequestModel {
        firstName: string;
        lastName: string;
        gender: string;
        dateOfBirth: string;
        postalCode: string;

        constructor(obj?: Portico.Services.Legacy.EnrollmentService.Models.PatientLookupRequestModel){
            this.firstName = null;
            this.lastName = null;
            this.gender = null;
            this.dateOfBirth = null;
            this.postalCode = null;

            if(obj){
                this.firstName = obj.firstName || null;
                this.lastName = obj.lastName || null;
                this.gender = obj.gender || null;
                this.dateOfBirth = obj.dateOfBirth || null;
                this.postalCode = obj.postalCode || null;
            }
        }

        public toModel(): Portico.Services.Legacy.EnrollmentService.Models.PatientLookupRequestModel {
            return {
                firstName: this.firstName,
                lastName: this.lastName,
                gender: this.gender,
                dateOfBirth: this.dateOfBirth,
                postalCode: this.postalCode,
            };
        }
    }   
}